import { render, staticRenderFns } from "./SidebarWidget.vue?vue&type=template&id=1ebcea62&"
import script from "./SidebarWidget.vue?vue&type=script&lang=ts&"
export * from "./SidebarWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports